import * as React from 'react';
import { Switch } from 'react-router';
import TurboCashContainer from '../../containers/mx/turboCash/TurboCashContainer';
import SimulatorStepContainer from '../../containers/mx/creditoReal/SimulatorStepContainer';
import PersonalDataStepContainer from '../../containers/mx/creditoReal/PersonalDataStepContainer';
import HomeDataStepContainer from '../../containers/mx/creditoReal/HomeDataStepContainer';
import WorkDataStepContainer from '../../containers/mx/creditoReal/WorkDataStepContainer';
import PrivacyBureauTermsStepContainer from '../../containers/mx/creditoReal/PrivacyBureauTermsStepContainer';
import ReferencesStepContainer from '../../containers/mx/creditoReal/ReferencesStepContainer';
import InsurancesStepContainer from '../../containers/mx/creditoReal/InsurancesStepContainer';
import CreditHistoryStepContainer from '../../containers/mx/creditoReal/CreditHistoryStepContainer';
import FilesUploadStepContainer from '../../containers/mx/creditoReal/FilesUploadStepContainer';
import SummaryStepContainer from '../../containers/mx/creditoReal/SummaryStepContainer';
import * as RoutesConstant from '../../constants/RoutesConstant';
import PageContainer from '../../containers/PageContainer';
import NotFoundContainer from '../../containers/NotFoundContainer';
import NotEligibleStepContainer from '../../containers/mx/creditoReal/NotEligibleStepContainer';
import ThanksStepContainer from '../../containers/mx/creditoReal/ThanksStepContainer';
import { STEPS_GRAPH_CMS } from '../../constants/StepConstants';
import LoadingView from './mx/LoadingView';
import { LOGIN } from '../../constants/LabelConstants';
import TurboCashSimulatorContainer from '../../containers/mx/creditoReal/TurboCashSimulatorContainer';
import TurboCashThanksContainer from '../../containers/mx/turboCash/TurboCashThanksContainer';
import qs from 'query-string';
import { APP_MOBILE, APP_WEB } from '../../constants/GlobalConstants';
import { RoutesViewState } from '../../types/mx/creditoReal/components';
import SimulatorProfileContainer from '../../containers/mx/creditoReal/SimulatorProfileContainer';

export default class RoutesView extends React.Component<{ isLoaded: boolean }, RoutesViewState>{
    constructor(props) {
        super(props);
        this.state = {
            app: APP_WEB,
            windowSize: window.innerWidth
        };
        this.getWindowSize = this.getWindowSize.bind(this);
    }

    getWindowSize() {
        const params = qs.parse(location.search);
        this.setState({
            windowSize: window.innerWidth,
            app: params['app'] === APP_MOBILE ? APP_MOBILE : APP_WEB
        });
    }

    getRoutes(app) {
        return <Switch>
            <PageContainer exact path={`${RoutesConstant.CALCULATOR_PATH}`}
                component={() => <SimulatorStepContainer landing />} step="0" landing hideBrandWizard
                fluidLayout />
            <PageContainer exact path={`${RoutesConstant.CALCULATOR_PATH}/:token`}
                component={() => <SimulatorStepContainer landing />} needsLogin step="0" landing
                hideBrandWizard fluidLayout />
            <PageContainer exact path={`${RoutesConstant.SSO_TOKEN_PATH}`}
                component={() => <LoadingView description={LOGIN.SSO_AUTHENTICATING} />}
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.PERSONAL_DATA_PATH}`}
                component={PersonalDataStepContainer} needsLogin step="1"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.PERSONAL_DATA_PATH}/:token`}
                component={PersonalDataStepContainer} needsLogin step="1"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.IDENTITY_VALIDATION_PATH}/:token`}
                component={HomeDataStepContainer} needsLogin step="3"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.HOME_PATH}/:token`}
                component={HomeDataStepContainer} needsLogin step="3"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.PRIVACY_BUREAU_VALIDATION_PATH}/:token`}
                component={PrivacyBureauTermsStepContainer} needsLogin step="4"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.WORK_PATH}/:token`}
                component={WorkDataStepContainer} needsLogin step="5"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.REFERENCES_PATH}/:token`}
                component={ReferencesStepContainer} needsLogin step="6"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.INSURANCES_PATH}/:token`}
                component={InsurancesStepContainer} needsLogin step="7"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.FILES_UPLOAD_PATH}/:token`}
                component={FilesUploadStepContainer} needsLogin step="8"
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.SUMMARY_PATH}/:token`} step="-"
                component={SummaryStepContainer} needsLogin
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.CREDIT_HISTORY_PATH}/:token`}
                component={CreditHistoryStepContainer} needsLogin step="4"
                graphId={STEPS_GRAPH_CMS.STEP_BUREAU}
                hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.BUREAU_NOT_ELIGIBLE}`} step="-"
                component={NotEligibleStepContainer} needsLogin hideHeader hideFooter fluidLayout
                customClass="error-not-eligible" hideBrandWizard />
            <PageContainer exact path={`${RoutesConstant.THANKS}`}
                component={ThanksStepContainer} needsLogin hideHeader hideFooter fluidLayout />
            <PageContainer exact path={`${RoutesConstant.TURBO_CASH_CALCULATOR}`}
                component={TurboCashSimulatorContainer} simulatorTurboCash landing hideBrandWizard
                hideFooter hideHeader={false} needsLogin />
            <PageContainer exact path={`${RoutesConstant.PROFILE_CALCULATOR}/:token`}
                component={SimulatorProfileContainer} simulatorProfileCreditoReal landing hideBrandWizard
                hideFooter hideHeader={false} needsLogin />
            <PageContainer exact path={`${RoutesConstant.THANKS_TURBOCASH}`}
                component={() => <TurboCashThanksContainer landing app={app} />} turboCash landing
                hideBrandWizard fluidLayout needsLogin app={app} />
            <PageContainer exact path={`${RoutesConstant.TURBO_CASH}/:token`}
                component={() => <TurboCashContainer landing app={app} />} turboCash landing
                hideBrandWizard fluidLayout needsLogin app={app} />
            <PageContainer component={NotFoundContainer} hideHeader hideFooter fluidLayout />
        </Switch>;
    }

    render() {
        const { app } = this.state;
        const view = this.props.isLoaded ?
             this.getRoutes(app) : <LoadingView description={LOGIN.SSO_AUTHENTICATING} />;
        return (
            <React.Fragment>
                {view}
            </React.Fragment>
        );
    }
}
